import React, { useState } from 'react';
import ImageGallerfreewater from '../components/ImageGallerfreewater';
import IRCTVDonationCard from "./IRCTVDonationCard";
import { useStats } from '../hooks/useStats';

const IRCWATER = () => {
  const { stats, loading } = useStats();
  const [waterQuantity, setWaterQuantity] = useState(1);
  const waterBaseAmount = 20;

  // Format date for display
  const formatDisplayDate = (dateString) => {
    if (!dateString) return '31-Jan-2025';
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Format number with commas
  const formatNumber = (num) => {
    if (!num && num !== 0) return 'Loading...';
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Water Supply handlers
  const handleWaterIncrease = () => setWaterQuantity(prev => prev + 1);
  const handleWaterDecrease = () => setWaterQuantity(prev => prev > 1 ? prev - 1 : 1);
  const handleWaterQuantityChange = (e) => {
    const value = parseInt(e.target.value) || 1;
    setWaterQuantity(value > 0 ? value : 1);
  };

  const waterTotalAmount = waterQuantity * waterBaseAmount;

  const handlePhoneClick = (phoneNumber) => {
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    const telLink = `tel:${cleanedNumber}`;
    window.location.href = telLink;
  };

  if (loading) return <div className="loading">Loading statistics...</div>;

  return (
    <>
      <div className="about-us-container">
        <section className="activities-details">
          <button 
            onClick={() => window.history.back()}
            style={{
              marginBottom: '10px',
              padding: '8px 10px',
              backgroundColor: '#255fe8',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            ← Back to All Activities
          </button>
          <div className="activity-intro">
            <h2>OUR ACTIVITIES</h2>
            <p>
              All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
            </p>
          </div>

          <ImageGallerfreewater />

          {/* IRC Free Water Supply */}
          <div className="activity-card">
            <div className="activity-header">
              <h3>IRC FREE WATER SUPPLY (IFWS)</h3>
            </div>
            <div className="activity-content">
              <p>
                IRC supplies free clean drinking water and water for storage and use to slums and localities with water scarcity in the city.
              </p>
              <p>
                IRC also supplies drinking water at public places and government hospitals.
              </p>

              {/* Unit 1 */}
              <div className="clinic-card">
                <p><strong>Unit:</strong> 1 - Rohila Gali</p>
                <p><strong>Name:</strong> IRC Free Water Supply</p>
                <p><strong>Address:</strong> H.No 1-23-100, Rohila Gali, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 1-Feb-2021</p>
                <p><strong>Drinking Water Supply:</strong> {formatNumber(stats.water_rohila_drinking)} liters/Day (till {formatDisplayDate(stats.water_rohila_date)})</p>
                <p><strong>Utility Water Supply:</strong> {formatNumber(stats.water_rohila_utility)} liters/Day (till {formatDisplayDate(stats.water_rohila_date)})</p>
                <p><strong>Contact No: </strong><span
                  className="contact-number"
                  onClick={() => handlePhoneClick('7537-9999-00')}
                  style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                >
                  7537-9999-00
                </span>
                </p>
              </div>

              {/* Unit 2 */}
              <div className="clinic-card">
                <p><strong>Unit:</strong> 2 - Ambar Hill</p>
                <p><strong>Name:</strong> IRC Free Water Supply</p>
                <p><strong>Address:</strong> Gut No:250, Plot No: 12 & 13, Jatwada Road, Beside Mohammadi Masjid, Ambar Hill, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 8-Jun-2023</p>
                <p><strong>Utility Water Supply:</strong> {formatNumber(stats.water_ambarhill_utility)} liters/Day (till {formatDisplayDate(stats.water_ambarhill_date)})</p>
                <p><strong>Contact No: </strong><span
                  className="contact-number"
                  onClick={() => handlePhoneClick('7537-9999-00')}
                  style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                >
                  7537-9999-00
                </span>
                </p>
              </div>
            </div>

            {/* Water Supply Donation Card */}
            <IRCTVDonationCard
              title="IRC FREE WATER SUPPLY (IFWS)"
              subtitle="Provide Clean Water to Those in Need"
              description="Your donation helps us supply clean drinking water to underserved communities. Every ₹20 provides one water jar to a family in need."
              baseAmount={waterBaseAmount}
              quantity={waterQuantity}
              onIncrease={handleWaterIncrease}
              onDecrease={handleWaterDecrease}
              onQuantityChange={handleWaterQuantityChange}
              totalAmount={waterTotalAmount}
              purpose={`Water supply for ${waterQuantity} famil${waterQuantity > 1 ? 'ies' : ''}`}
              behalf="Donation Options"
              behalfdescription="Choose how many water jars you want to provide"
              showQuantityControls={true}
              serviceType="water"
              buttonText="Donate for Water"
            />
          </div>
        </section>
      </div>
    </>
  );
};

export default IRCWATER;